import React from 'react';
import './svg-loader.ts';

interface SvgIconProps {
    imgId: string;
    sizeX: string;
    sizeY: string;
    className?: string;
    dataAtid?: string;
    title?: string;
    viewBox?: string;
}

export function SvgIcon({
    imgId = 'default',
    sizeX = '20px',
    sizeY = '20px',
    className,
    dataAtid,
    title,
    viewBox
}: SvgIconProps) {
    return (
        <svg width={sizeX} height={sizeY} className={className} data-atid={dataAtid} viewBox={viewBox}>
            {title && <title>{title}</title>}
            <use xlinkHref={`#${imgId}-sl`} width={sizeX} height={sizeY} style={{ pointerEvents: 'none' }} />
        </svg>
    );
}

export const svgIconExists = (imgId: string) => {
    try {
        return !!document.querySelector(`symbol[id='${imgId}-sl']`);
    } catch (e) {
        return false;
    }
};
